module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {}, [_c('span', [_vm._v(_vm._s(_vm.itemValues.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68652666","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/ThirdLayer.vue
// module id = 166
// module chunks = 4